import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { CloudOutlined, HistoryOutlined, Lock } from '@mui/icons-material';
import VersionProperty from 'components/Packages/PackagePopout/VersionProperty';
import { LOCALE_DATE_OPTIONS } from 'contracts/constants';
import type { FC } from 'react';
import type { PackageContentInfo, PackageVersionType } from 'services/graphql/generated/schemas';

type LatestVersionInfoLineProps = {
  baseUrl: string;
  getPackageVersion: Partial<PackageVersionType> | undefined;
  packageContent: Partial<PackageContentInfo> | undefined;
  modifiedAt: string;
};
const LatestVersionInfoLine: FC<LatestVersionInfoLineProps> = ({
  baseUrl,
  getPackageVersion,
  modifiedAt,
  packageContent
}) => {
  const deployedVersions = packageContent?.publishedVersions ? parseInt(packageContent.publishedVersions, 10) : 0;
  const availableVersions = packageContent?.availableVersions ? parseInt(packageContent.availableVersions, 10) : 0;

  // eslint-disable-next-line react/no-unstable-nested-components
  const LastDeployedVersion = () => (
    <VersionProperty title="Last modified" link={`${baseUrl}/package`} icon={<Lock />} iconColor="warning">
      <H4 fontWeight="bold" color="primaryText">
        {getPackageVersion?.version}
      </H4>
      <H4 fontWeight="semiBold" color="secondary" ml="sm">
        {new Date(modifiedAt).toLocaleString('nl', LOCALE_DATE_OPTIONS)}
      </H4>
    </VersionProperty>
  );

  // eslint-disable-next-line react/no-unstable-nested-components
  const History = () => {
    const url = baseUrl.split('/');
    url.pop();

    return (
      <VersionProperty title="History" link={`${url.join('/')}/versions`} icon={<HistoryOutlined />}>
        <H4 fontWeight="bold" ml="xs" color="primaryText">
          {availableVersions} Version{availableVersions !== 1 ? 's' : ''}
        </H4>
      </VersionProperty>
    );
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const Deployments = () => (
    <VersionProperty title="Deployed" link={`${baseUrl}/deployments`} icon={<CloudOutlined />}>
      <H4 fontWeight="bold" ml="xs" color="primaryText">
        {deployedVersions} Version{deployedVersions !== 1 ? 's' : ''}
      </H4>
    </VersionProperty>
  );

  return (
    <FlexLayout mt="sm" justifyContent="space-between">
      <LastDeployedVersion />
      <FlexLayout>
        <History />
        <Box mr="xxl" />
        <Deployments />
      </FlexLayout>
    </FlexLayout>
  );
};

export default LatestVersionInfoLine;
